import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useOutletContext } from 'react-router-dom';
import api from '../../api/axiosInstance';
import { useModal } from '../../contexts/ModalContext';

const EmailValidationMain = () => {
  const navigate = useNavigate();
  const [setBreadcrumb, setBreadcrumbLink] = useOutletContext();
  const { openModal } = useModal();
  const [credits, setCredits] = useState(null);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creditModalOpen, setCreditModalOpen] = useState(false);
  const [creditInput, setCreditInput] = useState(1000);
  const [isBuying, setIsBuying] = useState(false);

  useEffect(() => {
    setBreadcrumb(['Email Validator']);
    setBreadcrumbLink(['']);
    fetchData();
  }, [setBreadcrumb, setBreadcrumbLink]);

  const fetchData = async () => {
    try {
      const [creditRes, reqRes] = await Promise.all([
        api.get('/email-verify/credits'),
        api.get('/email-verify/validation-requests')
      ]);
      if (!creditRes.data.error) {
        setCredits(creditRes.data.emailVerifyCredits);
      } else {
        openModal('failure', creditRes.data.message);
      }
      if (!reqRes.data.error) {
        setRequests(reqRes.data.requests);
      } else {
        openModal('failure', reqRes.data.message);
      }
    } catch (error) {
      const msg = error.message === 'Network Error' ? 'No Internet Connection.' : error.message;
      openModal('failure', msg);
    } finally {
      setLoading(false);
    }
  };

  const handleBuyCredits = async () => {
    if (creditInput < 1000) return openModal('failure', 'Minimum 1000 credits required.');
    setIsBuying(true);
    try {
      const res = await api.post('/email-verify/buy', { credits: creditInput });
      if (!res.data.error) {
        window.location.href = res.data.paymentLink;
      } else {
        openModal('failure', res.data.message);
      }
    } catch (error) {
      const msg = error.message === 'Network Error' ? 'No Internet Connection.' : error.message;
      openModal('failure', msg);
    } finally {
      setIsBuying(false);
    }
  };

  return (
    <>
      {creditModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Buy Credits</h3>
            <label className="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">Enter Credits (Min 1000)</label>
            <input
              type="number"
              min="1000"
              value={creditInput}
              onChange={(e) => setCreditInput(parseInt(e.target.value))}
              className="w-full px-3 py-2 mb-3 border rounded-lg dark:bg-gray-700 dark:text-white"
            />
            <div className="text-sm text-gray-600 dark:text-gray-300 mb-4">
              Cost: ₹{(creditInput * 0.03).toFixed(2)} ({creditInput} x 0.03)
            </div>
            <div className='w-full grid grid-cols-3 gap-2'>
              <div className="my-auto me-auto">
                <img className='w-full' alt='' src='/images/icons/pay_methods_branding.png'/>
              </div>
              <div className="col-span-2 ms-auto">
                <button
                  onClick={() => setCreditModalOpen(false)}
                  className="px-4 py-2 me-2 bg-gray-200 dark:bg-gray-600 text-sm rounded-lg"
                >Cancel</button>
                <button
                  onClick={handleBuyCredits}
                  disabled={isBuying}
                  className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-sm rounded-lg"
                >{isBuying ? 'Processing...' : 'Buy Now'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="p-4 bg-white sm:p-6 dark:bg-gray-800">
        <div className="grid grid-cols-2 mb-2">
          <div className="col align-bottom">
            <h3 className="text-xl pt-3 font-bold text-gray-900 dark:text-white">Email Validator</h3>
          </div>
          <div className="col text-sm mt-3 mb-2 w-full text-right font-normal text-gray-500 dark:text-gray-400">
            <Link to={`./new-request`}>
              <button className="bg-blue-600 text-white px-4 py-2 rounded-full hover:bg-blue-700">
                New Validation Request
              </button>
            </Link>
          </div>
        </div>

        <div className='grid grid-cols-2 mb-3 border shadow p-2 rounded'>
          <div className="col-span-2 sm:col-span-1">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Available Credits</label>
            <div className="text-xl font-semibold text-gray-900 dark:text-white">{credits}</div>
          </div>
          <div className='pt-2'>
            <button
              onClick={() => setCreditModalOpen(true)}
              className="float-end bg-green-600 text-white px-4 py-2 rounded-full hover:bg-green-700"
            >
              Add Credits
            </button>
          </div>
        </div>

        {/* Pagination and Limit Selection */}
        {/* <div className="flex items-center justify-between mb-4">
          <div className="flex">
            <button
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className={`flex items-center justify-center py-2 px-5 text-xs font-medium text-gray-900 bg-white border border-gray-200 hover:bg-gray-100 rounded-s-lg ${currentPage === 1 ? 'opacity-70 cursor-not-allowed' : ''}`}
            >
              <svg className="w-3.5 h-3.5 me-2 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 5H1m0 0 4 4M1 5l4-4" />
              </svg>
              Prev
            </button>
            <button
              onClick={handleNextPage}
              disabled={pageEnd >= Total}
              className={`flex items-center justify-center py-2 px-5 text-xs font-medium text-gray-900 bg-white border border-gray-200 hover:bg-gray-100 rounded-e-lg ${pageEnd >= Total ? 'opacity-70 cursor-not-allowed' : ''}`}
            >
              Next
              <svg className="w-3.5 h-3.5 ms-2 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
              </svg>
            </button>
          </div>
          <div className="text-sm text-gray-500 dark:text-gray-400">
            Show <span className="font-semibold">{pageStart} - {pageEnd}</span> of <span className="font-semibold">{Total}</span>
          </div>
          <div>
            <select value={limit} onChange={handleLimitChange} className="py-2 px-3 border text-sm rounded-lg border-gray-300 rounded">
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
        </div> */}

        <div className="flex flex-col">
          <div className="overflow-x-auto shadow rounded-lg">
            <div className="inline-block min-w-full">
              <div className="overflow-hidden sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-600">
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      {['File Name', 'Total', 'Valid', 'Invalid', 'Credits Used', 'Status', 'Requested At', 'Download'].map(header => (
                        <th key={header} className="p-4 text-xs font-medium text-left text-gray-500 uppercase dark:text-white">{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="bg-white dark:bg-gray-800">
                    {loading ? (
                      <tr>
                        <td colSpan="5" className="p-4 text-center">
                          <div role="status">
                            <svg aria-hidden="true" className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600 inline-block" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                            </svg>
                            <span className="sr-only">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      requests.length > 0 ? (
                        requests.map((request) => (
                          <tr key={request._id}>
                            <td className="p-4 text-sm font-normal whitespace-nowrap">{request.fileName}</td>
                            <td className="p-4 text-sm font-normal whitespace-nowrap">{request.totalEmails}</td>
                            <td className="p-4 text-sm font-normal whitespace-nowrap">{request.validCount}</td>
                            <td className="p-4 text-sm font-normal whitespace-nowrap">{request.invalidCount}</td>
                            <td className="p-4 text-sm font-normal whitespace-nowrap">{request.creditsUsed}</td>
                            <td className="p-4 text-sm whitespace-nowrap">
                              <span className="rounded-full capitalize bg-orange-100 text-orange-800 text-xs font-medium mr-2 px-2.5 py-0.5 dark:bg-gray-700 dark:text-orange-400 border dark:border-orange-500">
                                {request.status}
                              </span>
                            </td>
                            <td className="p-4 text-sm font-normal whitespace-nowrap">{new Date(request.createdAt).toLocaleString()}</td>
                            <td className="px-4 py-2 text-sm">
                              {request.status === 'completed' ? (
                                <a
                                  href={request.downloadUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="py-2 px-5 mb-2 me-2 text-xs font-medium text-gray-900 bg-white rounded-full border border-gray-200 hover:bg-gray-100"
                                >Download</a>
                              ) : (
                                <button disabled className="text-white bg-green-700 hover:bg-green-800 focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2 mb-2 cursor-not-allowed">Download</button>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="p-4 text-sm font-normal text-gray-900 dark:text-white">No Requests Yet</td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailValidationMain;
